export function getHeroSlidesToLoad(activeIndex, slideCount) {
  if (slideCount <= 1) return new Set([0]);

  const next = (activeIndex + 1) % slideCount;
  const prev = (activeIndex - 1 + slideCount) % slideCount;
  return new Set([activeIndex, next, prev]);
}

export function preloadImage(src) {
  if (!src || typeof window === 'undefined') return;
  const image = new Image();
  image.src = src;
}
